"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleSelectFilter = exports.filterGroups = exports.getParticipatingGroups = exports.getFoundedGroups = void 0;
const filters_1 = require("../constants/filters");
const getFoundedGroups = (groups) => groups === null || groups === void 0 ? void 0 : groups.filter(group => group.isFounder);
exports.getFoundedGroups = getFoundedGroups;
const getParticipatingGroups = (groups) => groups === null || groups === void 0 ? void 0 : groups.filter(group => !group.isFounder && group.canLeave);
exports.getParticipatingGroups = getParticipatingGroups;
const filterGroups = (type, groups) => {
    switch (type) {
        case filters_1.FilterGroupType.FoundedGroups:
            return (0, exports.getFoundedGroups)(groups);
        case filters_1.FilterGroupType.ParticipatingGroups:
            return (0, exports.getParticipatingGroups)(groups);
        default:
            return groups;
    }
};
exports.filterGroups = filterGroups;
const toggleSelectFilter = (category, identifier) => category.map(filterGroup => {
    return Object.assign(Object.assign({}, filterGroup), { items: filterGroup.items.map(item => {
            if (item.identifier === identifier) {
                return Object.assign(Object.assign({}, item), { isSelected: true });
            }
            else {
                return Object.assign(Object.assign({}, item), { isSelected: false });
            }
        }) });
});
exports.toggleSelectFilter = toggleSelectFilter;
